import createInstance from './createInstance';
import extension from './extension';
import platform from './platform';
import workflowRun from './workflowRun';
export { WorkflowRunState } from './workflowRun';
const buildHTTPClient = (instance) => {
    return {
        instance,
        extension: extension(instance),
        platform: platform(instance),
        workflowRun: workflowRun(instance),
    };
};
export function createHTTPClient(configOrInstance) {
    const instance = createInstance(configOrInstance);
    return buildHTTPClient(instance);
}
//# sourceMappingURL=index.js.map